import { Factory } from 'fishery';
import { Address } from '@trukt/types/Address';
import { NonNullableKeys } from '@trukt/types/NonNullableKeys';

export const addressFactory = Factory.define<NonNullableKeys<Address>>(({ sequence }) => ({
  guid: sequence.toString(),
  city: 'Sacramento',
  state: 'California',
  country: 'USA',
  latitude: '24',
  longitude: '25',
  street1: '9300 Tech Center Dr',
  street2: 'Sesame St',
  zipCode: '95624',
}));
